import(/* webpackMode: "eager" */ "/workspace/app/popular-now/components/Products.jsx")